import type {Store} from '@reduxjs/toolkit'
import type * as React from 'react'
import {Provider as ReduxProvider} from 'react-redux'
import {logger} from 'tizra'
import type {SetRequired} from 'type-fest'
import {ComponentWrapper, type ComponentWrapperProps} from './ComponentWrapper'

const log = logger('blocks/BlockWrapper')

interface BlockWrapperProps
  extends SetRequired<ComponentWrapperProps, 'hydrate'> {
  Router: React.FC<{children: React.ReactNode}>
  store: Store
  routerProps?: any // for tests
}

/**
 * Block wrapper for both server-side and client-side rendering, however this is
 * NOT used for Storybook. For the Storybook wrapper, see blockDecorator.
 */
export const BlockWrapper = ({
  Router,
  routerProps,
  store,
  ...props
}: BlockWrapperProps) => (
  <ReduxProvider store={store}>
    <Router
      future={{v7_relativeSplatPath: true, v7_startTransition: true}}
      {...routerProps}
    >
      <ComponentWrapper {...props} />
    </Router>
  </ReduxProvider>
)
